<template>
  <header>
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: 'xj-header'
}
</script>